module.exports = __webpack_public_path__ + "static/media/webdesign-services-img28.5982520c.jpg";